export default "__VITE_ASSET__4f08a505__"